import {GetIssuePointCabinetResponsePayload} from '../../../../../shared/models/api/getIssuePointCabinetResponsePayload';
import React from 'react';
import {GenericPointFeature, LngLat} from '@yandex/ymaps3-types';
import {NavigationProp, ParamListBase} from '@react-navigation/native';
import {EsiaRegCardForm, KidSubform} from '../form/model';
import {AuthorizeEsiaResponsePayload} from '../../../../../shared/models/api/authorizeEsiaResponsePayload';
import {mapFormValuesToEsiaRegData} from '../formMapper';
import {esiaRegisterCardApplication} from '../../../../../redux/actions/login';
import {ServerValidationError} from '../../../../../shared/models/serverValidationError';
import {DeliveryType} from '../../../../../types/registerCardApplicationRequestPayload';
import {ParentSaturated} from '../../esiaRegCardState/model';
import {RegisterClientCabinetRequestPayload} from '../../../../../shared/models/api/registerClientCabinetRequestPayload';
import {storage, StorageKeys} from '../../../../../shared/storage';

export interface Props {
  onClose: () => void;
}

export interface ViewProps {
  loading?: boolean;
  mapData: GetIssuePointCabinetResponsePayload[];
  onPressMarker: (marker: GetIssuePointCabinetResponsePayload | null) => void;
  currentMarker: GetIssuePointCabinetResponsePayload | null;
  centerPoint: [number, number];
  zoomLevel?: number;
  isIssuePointDetailsVisible: boolean;
  setIsIssuePointDetailsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  markers?: GenericPointFeature<LngLat>[];
}

export const initialYandexZoomValue = 9;
export const initialGoogleZoomValue = 0.8;

export interface EsiaRegCardMapProps {
  onGoBack(): void;
  navigation?: NavigationProp<ParamListBase>;
  closeRegStepComponent?: () => void;
}

export type ApplicationRegistrationResult = 'success' | 'parentError' | 'parentKidError' | 'kidError' | 'error';

export interface showApplicationRegistrationResultModalParams {
  applicationRegistrationResult: ApplicationRegistrationResult;
  message?: string | undefined;
  _onClose?: () => void;
}

export const submitKidsDataAndSaveErrors = (
  kids: KidSubform[],
  esiaRegCardFormValues: EsiaRegCardForm,
  registrationInfo: AuthorizeEsiaResponsePayload,
  parentId: number | null,
  cardDeliveryInfo: {
    counterpartyDepartmentId: number;
    deliveryTypeId: DeliveryType;
    desiredAddress: string | undefined;
  },
) => {
  const allErrors: string[] = [];
  for (let confirmedKidsIndex = 0; confirmedKidsIndex < kids.length; confirmedKidsIndex++) {
    const kidSubmissionData = mapFormValuesToEsiaRegData(kids[confirmedKidsIndex], registrationInfo.token);
    kidSubmissionData.isEmailNotificationEnabled = esiaRegCardFormValues.isEmailNotificationEnabled;
    kidSubmissionData.isSmsNotificationEnabled = esiaRegCardFormValues.isSmsNotificationEnabled;
    kidSubmissionData.agentInfo = {
      document: kidSubmissionData.number,
      firstName: esiaRegCardFormValues.firstName,
      lastName: esiaRegCardFormValues.lastName,
      middleName: esiaRegCardFormValues.middleName,
      passport: `Паспорт ${esiaRegCardFormValues.number}, ${esiaRegCardFormValues.codeOrg}, ${esiaRegCardFormValues.date}, ${esiaRegCardFormValues.org}`,
      parentAccountId: parentId,
    };
    kidSubmissionData.linkParentAccount = esiaRegCardFormValues.isAccountLinkingEnabled;
    const registerKid = async () => {
      return await esiaRegisterCardApplication(
        {
          ...kidSubmissionData,
          codeOrg: '',
          ...cardDeliveryInfo,
        },
        false,
      ).catch((e) => {
        const error = e as ServerValidationError;
        const errorAssembled = `Ошибка регистрации ${kidSubmissionData.firstName} ${kidSubmissionData.lastName}. Код: ${
          error.data?.[0].message || error.message
        }`;
        allErrors.push(errorAssembled);
      });
    };
    registerKid();
  }
  return allErrors.join('. \n\n');
};

export const registerParentStoreActivationTokenReturnID = async (
  _parent: ParentSaturated | undefined,
  submissionData: RegisterClientCabinetRequestPayload,
  cardDeliveryInfo: {
    counterpartyDepartmentId: number;
    deliveryTypeId: DeliveryType;
    desiredAddress: string | undefined;
  },
) => {
  if (!_parent?.checked) return;
  const parentRegistrationResponse = await esiaRegisterCardApplication({
    ...submissionData,
    ...cardDeliveryInfo,
  });
  if (!parentRegistrationResponse?.counterpartyId) {
    throw new Error('Ошибка регистрации родителя');
  }
  await storage.setItem(StorageKeys.activationToken, parentRegistrationResponse.activationToken);
  return parentRegistrationResponse.counterpartyId;
};

export const setCardDeliveryInfo = (
  selectedDeliveryType: DeliveryType,
  currentMarker: GetIssuePointCabinetResponsePayload | null,
  russianPostDeliveryAddress: string,
) => {
  return {
    counterpartyDepartmentId: selectedDeliveryType === DeliveryType.IssuePoint ? currentMarker!.id : 531,
    deliveryTypeId: selectedDeliveryType,
    desiredAddress:
      selectedDeliveryType === DeliveryType.IssuePoint ? currentMarker?.address : russianPostDeliveryAddress,
  };
};
